import React from "react";

function CTASummary({
  ctaName,
  actionType,
  isActive,
}) {

  return (
    <div className="card mt-4">

      <div className="card-body">

        <h6 className="fw-bold mb-3">
          CTA Summary
        </h6>


        <div className="summary-row">

          <span>
            Name
          </span>

          <strong>
            {ctaName || "-"}
          </strong>

        </div>


        <div className="summary-row">

          <span>
            Action
          </span>

          <strong>
            {actionType}
          </strong>

        </div>


        <div className="summary-row">

          <span>
            Status
          </span>

          <strong
            className={
              isActive
                ? "text-success"
                : "text-secondary"
            }
          >

            {isActive
              ? "Active"
              : "Inactive"
            }

          </strong>

        </div>


        <div className="summary-row">

          <span>
            Tracking
          </span>

          <strong className="text-success">
            Enabled
          </strong>

        </div>

      </div>

    </div>
  );
}

export default CTASummary;